import React, { useRef, useState, useEffect } from "react";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CommonSelect from "../../../core/common/commonSelect";
import {
  AdmissionNumber,
  classSection,
  RollNumber,
  studentclass,
  studentName,
} from "../../../core/common/selectoption/selectoption";
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table'; // Import ColumnsType for type safety
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import TooltipOption from "../../../core/common/tooltipOption";
   
const BASE_URL = process.env.REACT_APP_BFF_URL;
// START Development By Loges ////
interface StudentAttend{
  admission_number: string;
  student_uid: number;
  attend_status?: string; // Add attendance field
  attendance_date: string;
  class_name: string;
  section_name: string;
  teacher_uid: number;
  attendance_remark: string;
  create_by: string;
  update_date: string;
  full_name: string;
  image_path: string;
}

const StudentClassAttendance = ({ studentsClassAtt: initialStudentsClassAtt = [] }: { studentsClassAtt?: StudentAttend[] }) => {
  const routes = all_routes;

   const [studentsClassAtt, setStudentsClassAtt] = useState<StudentAttend[]>(initialStudentsClassAtt);
   const [checkAttendanceExists, setCheckAttendanceExists] = useState<boolean | null>(null);
   const [isEditable, setIsEditable] = useState(false); // Track edit mode

  // Get Student Data From BFF
  const [classId, setClassId] = useState('Year 1');
  const [sectionId, setSectionId] = useState('Jupiter');
  //const [studentsClassAtt, setStudentsClassAtt] = useState([]);
  const [todayDt, setTodayDt] = useState(new Date().toISOString().split('T')[0]); // Store today's date

  const [attendanceStatus, setAttendanceStatus] = useState<{ [key: number]: string }>({});
  const [attendanceRemarks, setAttendanceRemarks] = useState<{ [key: number]: string }>({});

  useEffect(() => {
    const fetchStudentClassSection = async () => {
      try {
        const response = await fetch(`/api/studentClassAttend/getStudentClassSection/${classId}/${sectionId}`);
        const dataJson = await response.json();
        console.log('Fetch DATA from BFF: ',dataJson);
        setStudentsClassAtt(dataJson);

        // Populate attendanceStatus & attendanceRemarks from DB
        const statusMap = dataJson.reduce((acc: { [key: number]: string }, student: StudentAttend) => {
          acc[student.student_uid] = student.attend_status || '';
          return acc;
        }, {});
        setAttendanceStatus(statusMap);

        const remarksMap = dataJson.reduce((acc: { [key: number]: string }, student: StudentAttend) => {
          acc[student.student_uid] = student.attendance_remark || '';
          return acc;
        }, {});
        setAttendanceRemarks(remarksMap);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchStudentClassSection();
  }, [classId, sectionId]);

  // Check if attendance exists for today's date
  useEffect(() => {
    const checkAttendance = async () => {
        try {
            const response = await fetch(`/api/studentClassAttend/checkAttendanceExists/${classId}/${sectionId}/${todayDt}`);
            const data = await response.json();

            console.log("Attendance exists response:", data);

            if (data && typeof data.attendanceExists !== "undefined") {
                setCheckAttendanceExists(data.attendanceExists);
                setIsEditable(!data.attendanceExists); // If records exist, disable editing
            } else {
                console.error("Invalid API response format:", data);
            }
        } catch (error) {
            console.error("Error checking attendance:", error);
        }
    };

    checkAttendance();
}, [classId, sectionId, todayDt]);


  // const [attendanceStatus, setAttendanceStatus] = useState<{ [key: number]: string }>(
  //   initialStudentsClassAtt.reduce((acc, student) => {
  //     acc[student.student_uid] = student.attend_status || 'Present';
  //     return acc;
  //   }, {} as { [key: number]: string })
  // );

  // Handle radio button change
  const handleAttendanceChange = (studentUid: number, status: string) => {
    if (!isEditable) return; // Prevent editing when not in edit mode

    setAttendanceStatus((prevStatus) => ({
      ...prevStatus,
      [studentUid]: status,
    }));

    setStudentsClassAtt((prevStudents) =>
      prevStudents.map((student) =>
        student.student_uid === studentUid ? { ...student, attend_status: status } : student
      )
    );
  };

  const handleRemarkChange = (studentUid: number, value: string) => {
    if (!isEditable) return;

    setAttendanceRemarks((prevRemarks) => ({
      ...prevRemarks,
      [studentUid]: value,
    }));

    setStudentsClassAtt((prevStudents) =>
      prevStudents.map((student) =>
        student.student_uid === studentUid ? { ...student, attendance_remark: value } : student
      )
    );
  };

  const handleEditAttendance = () => {
    setIsEditable(true); // Enable fields for editing
  };

  const handleUpdateAttendance = async () => {
    const updatedStudents = studentsClassAtt.map(student => ({
      ...student,
      attend_status: attendanceStatus[student.student_uid],
      attendance_date: new Date().toISOString().split('T')[0], // Update attend status where by today's date
      attendance_remark: attendanceRemarks[student.student_uid],
      update_by: 'Admin',
      update_date: new Date().toISOString().split('T')[0],
    }));

    try {
      const response = await fetch('/api/studentClassAttend/updateStudentClassAttend', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedStudents),
      });

      const result = await response.json();
      console.log('Update result:', result);

      if (response.ok) {
        setIsEditable(false); // Disable fields after updating
      }
    } catch (error) {
      console.error('Error updating attendance:', error);
    }
  };

  const data = studentsClassAtt;

  const handleSaveAttendance = async () => {
    const studentsWithAttendance = studentsClassAtt.map(student => ({
      ...student,
      attend_status: attendanceStatus[student.student_uid] || 'Present',
      attendance_date: new Date().toISOString().split('T')[0], // Assuming you want to use today's date
      teacher_uid: 1, // Replace with actual teacher_uid
      // attendance_remark: 'Test Remark', // Replace with actual remark
      create_by: 'Admin', // Replace with actual create_by
      update_by: 'Admin', // Replace with actual update_by
      update_date: new Date().toISOString().split('T')[0], // Assuming you want to use today's date
    }));
    try {
      const response = await fetch('/api/studentClassAttend/addStudentClassAttend', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(studentsWithAttendance),
      });
      console.log('THE DATA TO SAVE IN DB:', studentsWithAttendance);
      const result = await response.json();
      console.log('Save attendance result:', result);

      if (response.ok) {
        setCheckAttendanceExists(true);
        setIsEditable(false); // Disable editing mode after saving
      }

    } catch (error) {
      console.error('Error saving attendance:', error);
    }
  };

  // end Development By Loges ////

  
  const [selectedOptions, setSelectedOptions] = useState(
    data.map(() => "Present") // Default to 'Present' for each row
  );

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  // Handle state change for each row
  const handleOptionChange = (index: any, value: any) => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[index] = value;
    setSelectedOptions(newSelectedOptions);
  };


  const columns: ColumnsType<StudentAttend> = [
    {
      title: "Admission No",
      dataIndex: "admission_number",
      render: (text: string, student: StudentAttend) => (
        <span>{student.admission_number}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "full_name",
      render: (text: string, student: StudentAttend) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img
              // src={`http://localhost:3005/api/studentClassAttend/uploads/479122d69423ca4c245b5d680ad47c08`}
              //src={`${BASE_URL}/api/studentClassAttend${student.image_path}`}
              src={`/api/studentClassAttend${student.image_path}`}
              className="img-fluid rounded-circle"
              alt="upload file"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
            <span>{student.full_name}</span>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Class",
      dataIndex: "class_name",
    },
    {
      title: "Section",
      dataIndex: "section_name",
    },

    {
      title: 'Attendance',
      dataIndex: 'attendance',
      render: (text: string, student: any) => (
        <div className="d-flex align-items-center check-radio-group flex-nowrap">
          {['Present', 'Late', 'Absent', 'Holiday', 'Medical Leave'].map((status) => (
            <label key={status} className="custom-radio">
              <input
                type="radio"
                name={`student${student.student_uid}`}
                value={status}
                checked={attendanceStatus[student.student_uid] === status}
                onChange={(e) => handleAttendanceChange(student.student_uid, e.target.value)}
                disabled={!isEditable} // Disable radio buttons if not in edit mode
              />
              <span className="checkmark" />
              {status}
            </label>
          ))}
        </div>
      ),
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      render: (_, student) => (
        <input
          type="text"
          className="form-control"
          placeholder="Enter Notes"
          value={attendanceRemarks[student.student_uid]}
          onChange={(e) => handleRemarkChange(student.student_uid, e.target.value)}
          disabled={!isEditable} // Disable input if not in edit mode
        />
      ),
    },
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Student Attendance</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Report</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Student Attendance
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
            </div>
          </div>
          {/* /Page Header */}
          {/* Student List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Student Attendance List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Admission No</label>
                              <CommonSelect
                                className="select"
                                options={AdmissionNumber}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Name</label>
                              <CommonSelect
                                className="select"
                                options={studentName}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-0">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={studentclass}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-0">
                              <label className="form-label">Section</label>

                              <CommonSelect
                                className="select"
                                options={classSection}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by A-Z
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1 active">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table dataSource={data} columns={columns} rowKey="student_uid"/>
              {/* /Student List */}
            </div>
            <div className="card-footer text-end">
                {!checkAttendanceExists ? ( // If no attendance records, show Save Attendance
                    <button className="btn btn-primary" onClick={handleSaveAttendance}>
                        Save Attendance
                    </button>
                ) : (
                    <>
                        {!isEditable ? (
                            <button className="btn btn-secondary" onClick={handleEditAttendance}>
                                Edit Attendance
                            </button>
                        ) : (
                            <button className="btn btn-primary" onClick={handleUpdateAttendance}>
                                Update Attendance
                            </button>
                        )}
                    </>
                )}
            </div>


          </div>
          {/* /Student List */}
        </div>
      </div>
    </div>
  );
};

//export default StudentAttendance;
export default StudentClassAttendance;
